module.exports = __webpack_public_path__ + "img/Sakelliou.33717e1f.jpg";